"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThemeRequest = void 0;
const use_storage_query_1 = require("./use-storage-query");
const useThemeRequest = (key, url, deps, enabled) => {
    const queryResult = (0, use_storage_query_1.useStorageQuery)(key, `/themes-v2${url}`, deps, {
        enabled: Boolean(enabled),
        staleTime: 100000000,
    });
    const { isLoading, error, data, refetch, isFetching, isRefetching, status } = queryResult;
    let res;
    if (!isLoading && data)
        res = data;
    return {
        isLoading,
        error,
        res,
        refetch,
        isFetching,
        isRefetching,
        status,
    };
};
exports.useThemeRequest = useThemeRequest;
